import noop from "lodash/noop";
import React, { FunctionComponent, ReactNode } from "react";
import { useIntl } from "react-intl";
import { faqLinks } from "@Utils/links";
import addressIcon from "./images/address.svg";
import billingIcon from "./images/billing.svg";
import deliveryIcon from "./images/delivery.svg";
import "./style.scss";

type TileType = "address" | "billing" | "delivery";

interface Props {
  children: ReactNode;
  onClick?: (type: TileType) => void;
  type: TileType;
  warningBanner?: {
    text: string;
    textLink: string;
  };
}

const getIcon = (type: TileType) => {
  switch (type) {
    case "address":
      return addressIcon;
    case "billing":
      return billingIcon;
    case "delivery":
      return deliveryIcon;
    default:
      return addressIcon;
  }
};

const CartOverviewTile: FunctionComponent<Props> = ({ children, onClick, warningBanner, type }) => {
  const intl = useIntl();

  return (
    <div className="CartOverviewTile">
      {(type === "address" || type === "billing") && (
        <div className="CartOverviewTile-change" onClick={() => (onClick ? onClick(type) : noop)}>
          {intl.formatMessage({
            id: "cheerz_CartOverviewTile_change",
          })}
        </div>
      )}
      <img alt="" className="CartOverviewTile-icon" src={getIcon(type)} />
      <div className="CartOverviewTile-title">
        <p className="CartOverviewTile-title-text">
          {intl.formatMessage({
            id: `cheerz_CartOverviewTile_title_${type}`,
          })}
        </p>
        {type === "delivery" && (
          <a
            className="CartOverviewTile-subtitle"
            href={`${faqLinks[type][intl.locale]}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {intl.formatMessage({
              id: `cheerz_CartOverviewTile_subtitle_${type}`,
            })}
          </a>
        )}
      </div>
      <div className="CartOverviewTile-content">{children}</div>
      {warningBanner && (
        <div className="CartOverviewTile-bannerContainer">
          <div className="CartOverviewTile-banner" onClick={() => (onClick ? onClick(type) : noop)}>
            <div className="CartOverviewTile-banner-text">{warningBanner.text}</div>
            <div className="CartOverviewTile-banner-link">{warningBanner.textLink}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartOverviewTile;
